// extracted by mini-css-extract-plugin
export default {"boxy":"LoginRegisterForm_boxy__SgIgd"};